import React from "react";
import Size from "shared/enums/Size";
import ManageParticipantTable from "./table";
import { ManageParticipantProps } from "./types";
import { useCopies } from "shared/hooks/useCopies";
import useManageParticipantService from "./service";
import { Modal, ModalBody, ModalHeader } from "shared/components/modal";

export default function ManageParticipant(props: ManageParticipantProps) {
  const tableRef = React.useRef<any>();
  const copies = useCopies();
  const service = useManageParticipantService(props);

  return (
    <Modal size={Size.FULL_WIDTH} className="manageOrgAdmin_manageParticpantModal">
      <ModalHeader
        left={
          <div className="manageOrgAdmin_summary">
            <strong className="manageOrgAdmin_summary_title">{copies.get("manage.participant")}</strong>
            {service.displayBuyMeetingCapMessage && (
              <span className="manageOrgAdmin_summary_meetingCapMsg">
                {copies.get("meeting.rep.buy.meeting.cap.msg")}
              </span>
            )}
          </div>
        }
        onClose={props.closeHandler}
      />
      <ModalBody>
        <div className="manageOrgAdmin_manageParticpantModal_search modal_searchBox">
          {tableRef?.current?.SearchBox}
        </div>
        <ManageParticipantTable
          tableRef={tableRef}
          programParticipantsManagedByOrgAdmin={service.programParticipantsManagedByOrgAdmin}
          manageChangeHandler={service.manageChangeHandler}
          programParticipantId={props.programParticipantId}
          isTradeProgram={service.isTradeProgram}
        />
      </ModalBody>
    </Modal>
  );
}
